import React from "react";
import { Media } from "../../../RichMessageTypes";
import { assertUnreachable } from "@fidget/common/utils/ts-utils";
import styles from "./MediaContent.css";

interface Props {
  media: Media;
}

export const MediaContent = ({ media }: Props) => {
  const renderImage = () => {
    return (
      <div className={styles.container}>
        <img src={media.mediaUrl} className={styles.image} />
      </div>
    );
  };

  const render = () => {
    switch (media.mediaType) {
      case "IMAGE":
        return renderImage();
      default:
        assertUnreachable(media.mediaType);
        return <></>;
    }
  };

  return render();
};
